<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


function initSlickVerticalWatcher() {
  const wrapper = document.querySelector('.productView-thumbnail-wrapper');
  const target = wrapper?.querySelector('.productView-for');

  if (!wrapper || !target) return;

  // 保存原始 style
  if (!wrapper.dataset.originalStyle) {
    wrapper.dataset.originalStyle = wrapper.getAttribute('style') || '';
  }

  // 初始化时判断
  if (!target.classList.contains('slick-vertical')) {
    wrapper.removeAttribute('style');
  }

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const hasSlickVertical = target.classList.contains('slick-vertical');

        if (hasSlickVertical) {
          wrapper.setAttribute('style', wrapper.dataset.originalStyle);
        } else {
          wrapper.removeAttribute('style');
        }
      }
    }
  });

  observer.observe(target, { attributes: true, attributeFilter: ['class'] });
}

// 等待 slick-initialized 出现后再执行
function waitForSlickInitialized(callback, timeout = 5000) {
  const interval = 100;
  let waited = 0;

  const timer = setInterval(() => {
    const slickTarget = document.querySelector('.productView-for.slick-initialized');
    if (slickTarget) {
      clearInterval(timer);
      callback();
    } else if ((waited += interval) >= timeout) {
      clearInterval(timer);
      console.warn('slick-initialized not found within timeout');
    }
  }, interval);
}

if (document.querySelector('.productView-thumbnail-wrapper .productView-for')) {
  waitForSlickInitialized(initSlickVerticalWatcher);
}


// === MBS: Patch Variant Swatch King output ===
// 在 vsk:variant:changed 之后接管，修复：
// 1. data-change-title 被覆盖
// 2. card-sku 嵌套 div
// document.addEventListener('vsk:variant:changed', function(e) {
//     const card = e.target;
//     if (!card) return;

//     let variantInfo;
//     try {
//         variantInfo = JSON.parse(e.detail.variantInformation);
//     } catch (err) {
//         console.warn('[MBS] vsk variantInformation parse failed', err);
//         return;
//     }

//     // selectedOptions 是数组：[{name:"Color", value:"Brushed Gold"}]
//     // 拼成 "Brushed Gold" 或 "Black / Large" 风格
//     const optionLabel = (variantInfo.selectedOptions || [])
//         .map(o => o.value)
//         .join(' / ');

//     // === 1. 更新 data-change-title ===
//     const titleLink = card.querySelector('.card-title');
//     if (titleLink && optionLabel) {
//         const textSpan = titleLink.querySelector('.text') || titleLink;
//         let changeTitle = textSpan.querySelector('[data-change-title]');
//         if (!changeTitle) {
//             changeTitle = document.createElement('span');
//             changeTitle.setAttribute('data-change-title', '');
//             textSpan.appendChild(changeTitle);
//             titleLink.classList.add('card-title-change');
//         }
//         const prefix = document.body.classList.contains('style_2_text_color_varriant') ? '' : ' - ';
//         changeTitle.textContent = prefix + optionLabel;
//     }

//     // === 2. 修复 card-sku 嵌套 + 更新 SKU ===
//     const skuEl = card.querySelector('.card-sku[data-product-sku]');
//     if (skuEl) {
//         if (variantInfo.sku) {
//             skuEl.textContent = 'SKU: ' + variantInfo.sku;   // textContent 自动清掉嵌套
//             skuEl.style.display = '';
//         } else {
//             skuEl.textContent = '';
//             skuEl.style.display = 'none';
//         }
//     }
// }, false);

// === MBS: Final fix — observer 强制纠正 + 初始清理 ===
(function() {
    'use strict';
    const PREFIX = document.body.classList.contains('style_2_text_color_varriant') ? '' : ' - ';

    function getColorFromInfo(info) {
        return info.option1
            || (info.selectedOptions || []).find(o => o.name && /colou?r/i.test(o.name))?.value
            || '';
    }

    // 从卡片当前选中的 swatch 找颜色（用于初始状态，无 variantInformation 时）
    function getCurrentColor(card) {
        // swatch-king 选中项有 aria-checked="true" 或 swatch-selected
        const selected = card.querySelector('[swatch-option="option1"].swatch-selected, li[aria-checked="true"]');
        if (selected) {
            return selected.getAttribute('data-value')
                || selected.getAttribute('orig-value')
                || selected.getAttribute('aria-label')
                || '';
        }
        return '';
    }

    function applyTitle(card, color) {
        const titleLink = card.querySelector('.card-title');
        if (!titleLink) return;
        const textSpan = titleLink.querySelector('.text');
        if (!textSpan) return;
        const cleanName = titleLink.getAttribute('data-product-title') || '';
        if (!cleanName || !color) return;

        const expected = PREFIX + color;
        const span = textSpan.querySelector('[data-change-title]');
        if (span && span.textContent === expected && textSpan.childNodes.length === 2) return;

        card._mbsLock = true;
        textSpan.textContent = cleanName + ' ';
        const newSpan = document.createElement('span');
        newSpan.setAttribute('data-change-title', '');
        newSpan.textContent = expected;
        textSpan.appendChild(newSpan);
        titleLink.classList.add('card-title-change');
        Promise.resolve().then(() => { card._mbsLock = false; });
    }

    function fixFromEvent(card) {
        if (!card._mbsInfo) return;
        applyTitle(card, getColorFromInfo(card._mbsInfo));
    }

    function ensureObserver(card) {
        if (card._mbsObs) return;
        const textSpan = card.querySelector('.card-title .text');
        if (!textSpan) return;
        const obs = new MutationObserver(() => {
            if (card._mbsLock) return;
            // observer 触发时优先用事件数据，没有就用当前选中
            if (card._mbsInfo) applyTitle(card, getColorFromInfo(card._mbsInfo));
            else applyTitle(card, getCurrentColor(card));
        });
        obs.observe(textSpan, { childList: true, subtree: true, characterData: true });
        card._mbsObs = obs;
    }

    // 切换时
    document.addEventListener('vsk:variant:changed', function(e) {
        const card = e.target;
        if (!card) return;
        try { card._mbsInfo = JSON.parse(e.detail.variantInformation); }
        catch (err) { return; }
        fixFromEvent(card);
        ensureObserver(card);
    }, false);

    // 初始清理：页面加载后扫所有卡片
    function initialClean() {
        document.querySelectorAll('.card-title').forEach(titleLink => {
            const textSpan = titleLink.querySelector('.text');
            if (!textSpan) return;
            if (textSpan.childNodes.length <= 2) return; // 正常的跳过

            const card = titleLink.closest('.product-item, .card');
            if (!card) return;
            const color = getCurrentColor(card);
            applyTitle(card, color);
            ensureObserver(card);  // 也给初始卡片挂 observer 防后续覆盖
        });
        console.log('[MBS] initial clean done');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialClean);
    } else {
        initialClean();
    }

    console.log('[MBS] fix loaded');
})();

// === MBS: Swatch color tooltip on hover ===
// hover 颜色 swatch 时，在鼠标旁显示颜色名浮层
(function() {
    'use strict';

    // --- 创建全局唯一的 tooltip 元素 ---
    let tooltip = null;
    function getTooltip() {
        if (tooltip) return tooltip;
        tooltip = document.createElement('div');
        tooltip.className = 'mbs-swatch-tooltip';
        tooltip.style.cssText = [
            'position: fixed',
            'z-index: 9999',
            'pointer-events: none',          // 关键：浮层不挡鼠标，避免闪烁
            'background: rgba(0,0,0,0.85)',
            'color: #fff',
            'padding: 4px 10px',
            'border-radius: 4px',
            'font-size: 12px',
            'line-height: 1.4',
            'white-space: nowrap',
            'transform: translate(-50%, -130%)',  // 显示在鼠标上方居中
            'opacity: 0',
            'transition: opacity 0.12s ease',
            'box-shadow: 0 2px 8px rgba(0,0,0,0.2)',
        ].join(';');
        document.body.appendChild(tooltip);
        return tooltip;
    }

    // --- 解析卡片 variants（带缓存）---
    function getVariants(card) {
        if (card._mbsVariants) return card._mbsVariants;
        const raw = card.dataset.jsonProduct;
        if (!raw) return null;
        try {
            card._mbsVariants = (JSON.parse(raw).variants) || [];
            return card._mbsVariants;
        } catch (err) {
            return null;
        }
    }

    // --- 当前最新鼠标位置（CustomEvent 没坐标，靠这个补）---
    let lastX = 0, lastY = 0;
    document.addEventListener('mousemove', function(e) {
        lastX = e.clientX;
        lastY = e.clientY;
        // 如果 tooltip 正在显示，让它跟随鼠标
        if (tooltip && tooltip.style.opacity === '1') {
            tooltip.style.left = lastX + 'px';
            tooltip.style.top = lastY + 'px';
        }
    }, { passive: true });

    // --- hover：显示颜色 tooltip ---
    document.addEventListener('vsk:swatch:hover', function(e) {
        const card = e.target;
        if (!card || !card.dataset) return;

        const variants = getVariants(card);
        if (!variants) return;

        const variant = variants.find(v => String(v.id) === String(e.detail.variantID));
        if (!variant) return;

        // 只取颜色（option1）
        const color = variant.option1;
        if (!color) return;

        const tip = getTooltip();
        tip.textContent = color;
        tip.style.left = lastX + 'px';
        tip.style.top = lastY + 'px';
        tip.style.opacity = '1';
    });

    // --- 鼠标移开 swatch 区域：隐藏 tooltip ---
    // swatch 判定：优先用 IIFE1 里已验证存在的 [swatch-option] 属性，.card-swatch 作兜底
    const SWATCH_SELECTOR = '[swatch-option], .card-swatch';

    document.addEventListener('mousemove', function(e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (!tooltip || tooltip.style.opacity !== '1') return;

        const overSwatch = e.target.closest && e.target.closest(SWATCH_SELECTOR);
        if (overSwatch) {
            // 还在 swatch 上 → 跟随
            tooltip.style.left = lastX + 'px';
            tooltip.style.top  = lastY + 'px';
        } else {
            // 已经离开 swatch → 立即隐藏（自我纠正，不再依赖 mouseout）
            tooltip.style.opacity = '0';
        }
    }, { passive: true });
})();





// 列表页：格式化折扣 + 清理 0% 假折扣（支持 load more / 异步加载）
(function () {
  function processBadge(el) {
    if (el.hasAttribute('data-sale-formatted')) return;

    const match = el.textContent.trim().match(/-?(\d+)%/);
    if (!match) return;

    const pct = parseInt(match[1], 10);
    el.setAttribute('data-sale-formatted', 'true');

    if (pct === 0) {
      // 0% 不是真折扣：隐藏 sale 价块，显示正常价块
      const saleBlock = el.closest('.price__sale');
      const priceWrap = el.closest('.price');
      if (saleBlock) saleBlock.style.display = 'none';
      if (priceWrap) {
        const regular = priceWrap.querySelector('.price__regular');
        if (regular) regular.style.display = 'block';
      }
    } else {
      el.textContent = `${pct}% OFF`;
    }
  }

  function run(root = document) {
    root.querySelectorAll('.label_sale_percent:not([data-sale-formatted])').forEach(processBadge);
  }

  // 初次执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  // 持续监听：load more / 翻页 / 无限滚动插入的新卡片
  const observer = new MutationObserver(muts => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue; // 只处理元素节点
        if (node.matches?.('.label_sale_percent')) {
          processBadge(node);
        } else {
          run(node); // 在新插入的子树里找 badge
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

// PAIRS WELL WITH"（即 complementary-products 模块）现在已经成功移动到了左下方，正好位于产品图片画廊和缩略图的下面
// (function () {
//   function attempt(tries) {
//     var cp = document.querySelector('complementary-products');
//     var moreItem = cp && cp.closest('.productView-moreItem');
//     var left = document.querySelector('.halo-productView-left');
//     if (moreItem && left) {
//       left.appendChild(moreItem);   // 成功
//       return;
//     }
//     if (tries > 0) {
//       setTimeout(function () { attempt(tries - 1); }, 300); // 没找到就 300ms 后重试
//     }
//   }
//   attempt(20); // 最多重试 20 次（约 6 秒），足够等元素加载出来
// })();